// extracted by mini-css-extract-plugin
export var list = "ValuesList-module--list--3bITK";
export var posts = "ValuesList-module--posts--1_Pc9";